import { useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';

export type ExtdevMSItem = {
  title: string;
  fieldName: string;
  value: number | boolean | string;
  type: 'bool' | 'string' | 'int';
};

type Response = Record<string, ExtdevMSItem[]>;

type ListType = 'scale' | 'customerDisplay';

function mapValue(item: ExtdevMSItem) {
  switch (item.type) {
    case 'bool':
      return !!item.value;
    case 'int':
      return Number(item.value);
    case 'string':
    default:
      return item.value;
  }
}

const getExtDevList = (listType: ListType) =>
  axios
    .get<unknown, AxiosResponse<Response>>(
      `https://localhost.erply.com:5658/${
        listType === 'scale' ? 'scaleList' : 'displayList'
      }`,
    )
    .then((res) => res.data);

export const fieldsToIndexedValues = (items: ExtdevMSItem[] = []) =>
  items?.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.fieldName]: mapValue(cur),
    }),
    {} as ExtdevMSItem,
  );

export const useExtDevList = (
  listType: ListType,
): { list: Response; error: boolean; retry: () => void } => {
  const [list, setList] = useState<Response>({});
  const [error, setError] = useState(false);

  const retry = () =>
    getExtDevList(listType)
      .then((res) => {
        setError(false);
        return setList(res);
      })
      .catch(() => setError(true));

  useEffect(() => {
    getExtDevList(listType)
      .then((res) => {
        setError(false);
        return setList(res);
      })
      .catch(() => setError(true));
  }, [listType]);

  return { list, error, retry };
};
